import(/* webpackMode: "eager" */ "/workspace/app/pricing/page.tsx");
